const getDisplayValue = (row, column) => {
    const value = row[column.field]

    if (typeof column.valueGetter !== "function") return value

    return column.valueGetter({
        id: row.id,
        field: column.field,
        row,
        value,
    })
}

const normalizeValue = (value) => String(value ?? "").toLocaleLowerCase("pt-BR")

const matchesFilter = (value, filter) => {
    const normalizedValue = normalizeValue(value)
    const operator = filter.operator || "contains"

    if (operator === "isEmpty") return normalizedValue.length === 0
    if (operator === "isNotEmpty") return normalizedValue.length > 0
    if (filter.value === undefined || filter.value === null || filter.value === "") return true

    if (operator === "isAnyOf") {
        const filterValues = Array.isArray(filter.value)
            ? filter.value
            : [filter.value]

        return filterValues.some(
            (filterValue) => normalizedValue === normalizeValue(filterValue)
        )
    }

    const normalizedFilter = normalizeValue(filter.value)

    if (operator === "equals") return normalizedValue === normalizedFilter
    if (operator === "startsWith") return normalizedValue.startsWith(normalizedFilter)
    if (operator === "endsWith") return normalizedValue.endsWith(normalizedFilter)

    return normalizedValue.includes(normalizedFilter)
}

export const filterRows = (rows, columns, filterModel) => {
    const columnsByField = new Map(columns.map((column) => [column.field, column]))

    return rows.filter((row) =>
        (filterModel.items || []).every((filter) => {
            const column = columnsByField.get(filter.field)
            if (!column) return true

            return matchesFilter(getDisplayValue(row, column), filter)
        })
    )
}

const getSortValue = (row, column) => {
    const value = row[column.field]

    if (typeof column.sortValueGetter !== "function") return value

    return column.sortValueGetter({
        id: row.id,
        field: column.field,
        row,
        value,
    })
}

const compareValues = (firstValue, secondValue) => {
    if (firstValue === secondValue) return 0
    if (firstValue === null || firstValue === undefined) return 1
    if (secondValue === null || secondValue === undefined) return -1

    if (typeof firstValue === "number" && typeof secondValue === "number") {
        return firstValue - secondValue
    }

    return String(firstValue).localeCompare(String(secondValue), "pt-BR", {
        numeric: true,
        sensitivity: "base",
    })
}

export const sortRows = (rows, columns, sortModel) => {
    const columnsByField = new Map(columns.map((column) => [column.field, column]))
    const activeSorts = (sortModel || []).filter(({ field, sort }) =>
        columnsByField.has(field) && (sort === "asc" || sort === "desc")
    )

    if (activeSorts.length === 0) return rows

    return [...rows].sort((firstRow, secondRow) => {
        for (const sortItem of activeSorts) {
            const column = columnsByField.get(sortItem.field)
            const comparison = compareValues(
                getSortValue(firstRow, column),
                getSortValue(secondRow, column)
            )

            if (comparison !== 0) {
                return sortItem.sort === "desc" ? -comparison : comparison
            }
        }

        return 0
    })
}

export const clampPage = (page, totalPages) => {
    if (totalPages < 1) return 1

    return Math.min(Math.max(page, 1), totalPages)
}
